module.exports = __webpack_public_path__ + "img/logo-sm.ac7ee85a.png";